import React from "react";
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { signatureTools } from "../../../constants/signature";
import { BASE_ASSETS_URL } from "../../../constants/constants";
import CtaOne from "@components/CTA/CtaOne";
import { CLMLinkPrimaryArrow } from "components/CLM/v3/Buttons";
import { GoArrowRight } from "react-icons/go";
import { CLMButtonPrimary } from "components/CLM/v3/Buttons";
import { BsArrowRight } from "react-icons/bs";

const PdfTools = () => {
  return (
    <div className="w-full mt-12 md:mt-20">
      <Head>
        <meta charSet="utf-8" />
        <title>Online PDF Tools - BoloForms</title>
        <meta
          name="description"
          content="Discover a suite of powerful PDF tools to help you manage your documents more efficiently. Merge, split, compress, and convert PDF files with ease. Try our online PDF tools today"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms" />
        <meta
          name="keywords"
          content="merge PDF, split PDF, rotate PDF, combine PDF, PDF converter, online PDF tools, PDF editor, PDF merge online, PDF split and merge, PDF rotate tool, PNG to PDF converter, JPEG to PDF converter, PDF to JPEG converter, PDF to PNG converter, PDF merge software, PDF split software, PDF rotate software, convert PDF to image, image to PDF converter, PDF conversion tool, PDF manipulation tools, free online PDF tools, edit PDF online, PDF merge and split, PDF compressor, PDF merger, PDF joiner, PDF cutter, PDF page rotation, batch PDF conversion, PDF processing tools"
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/pdf-tools/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Online PDF Tools - BoloForms" />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/signature/pdf-tools/"
        />
        <meta property="twitter:title" content="Online PDF Tools - BoloForms" />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/pdf-tools/"
        />
      </Head>

      <div className="w-full">
        <div className="max-w-[1280px] mx-auto px-4 md:px-10 rounded-xl relative flex flex-col gap-4 md:gap-10">
          <div className="max-w-3xl mx-auto text-center">
            <CtaOne
              heading1="Online PDF Tools"
              paragraph={`Free online PDF tools to merge, split, rotate, compress, convert, and many more. Manage your daily PDF tasks with our online PDF tools. 
Easily handle all your PDF documents without installing any software.`}
            />
          </div>
          <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {signatureTools.map((tool, index) => (
                <Link
                  href={tool.url}
                  key={index}
                  className="h-full bg-white border border-gray-300 rounded-xl transition duration-500 ease-in-out transform flex flex-col justify-between gap-6 group hover:shadow-lg hover:scale-105"
                >
                  <div className="h-full flex flex-col">
                    <div className="bg-cream rounded-xl px-4 py-14 flex items-center justify-center">
                      <Image
                        src={`${BASE_ASSETS_URL}/signature/tools/${tool.image}`}
                        alt={tool.title}
                        width={150}
                        height={150}
                        className="h-20 w-auto"
                      />
                    </div>
                    <div className="flex-1 h-full px-6 py-8 flex flex-col justify-between items-start gap-4">
                      <div className="flex-1 h-full">
                        <h3 className="text-xl font-bold flex items-center gap-2 flex-wrap text-gray-800 group-hover:text-blue-500 transition duration-300">
                          {tool.title} <GoArrowRight className="text-2xl" />
                        </h3>
                        <p className="text-gray-700 text-base font-medium mt-1">
                          {tool.description}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <CLMButtonPrimary
                          buttonText="Try It"
                          buttonUrl={tool.url}
                          icon={<BsArrowRight />}
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfTools;
